import { Languages } from "lucide-react";

import { type Language, useUiStore } from "@/stores/uiStore";

const ORDER: Language[] = ["pt-BR", "en", "es"];
const LABEL: Record<Language, string> = {
  "pt-BR": "PT",
  en: "EN",
  es: "ES",
};
const FULL_NAME: Record<Language, string> = {
  "pt-BR": "Português",
  en: "English",
  es: "Español",
};

export function LanguageToggle() {
  const language = useUiStore((s) => s.language);
  const setLanguage = useUiStore((s) => s.setLanguage);

  function cycle() {
    const idx = ORDER.indexOf(language);
    const next = ORDER[(idx + 1) % ORDER.length]!;
    setLanguage(next);
  }

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Idioma: ${FULL_NAME[language]} (clique para alternar)`}
      title={FULL_NAME[language]}
      className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-line bg-surface px-2 text-ink-700 transition-colors hover:border-brand-300 hover:text-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400/40"
    >
      <Languages className="h-4 w-4" />
      <span className="text-[11px] font-semibold tracking-wider">
        {LABEL[language]}
      </span>
    </button>
  );
}
